<div class="platform-reach-container" *ngIf="!showFallbackView">
  <!-- REVIEW: What's the best way to set this programmatically? -->
  <list-gauge-circle-chart [charts]="platformList"
                           [titlePosition]="'bottom'"
                           titleColor="#445166"
                           [hasBorderLeft]="false"
                           [chartHeader]="'measure.platform' | translate"
                           [titleTooltip]="'info_box.measure.platform_reach' | translate"
                           [statusTooltip]="'info_box.measure.local_report_status' | translate">
  </list-gauge-circle-chart>
</div>
<div *ngIf="showFallbackView" class="message">
  <platform-reach-placeholder></platform-reach-placeholder>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/platform-reache/platform-reache.component.html